/*
 * @Author: zhangxiangyi
 * @Date: 2024-09-27 09:16:50
 * @LastEditTime: 2024-09-27 09:16:54
 * @LastEditors: zhangxiangyi
 * @Description: description
 * @FilePath: /jc-nuxt-demo/app/locales/modules/bindCompany.js
 */
export const bindCompany_cn = {
  completeInfo: '完善信息',
  tip: '请完善您的信息，您可以在JCtrans上解锁更多服务，如提供咨询、报价和参加会议',
  selectCity: '选择公司所在城市',
  selectCityPH: '请输入公司所在城市',
  compNameCn: '公司中文名称',
  compNameCnPH: '请输入所在公司名称',
  compNameEn: '公司英文名称',
  compNameEnPH: '请输入所在公司英文名称',
  industry: '行业类型',
  phone: '手机号',
  phonePH: '请输入正确手机号码',
  verifyCode: '验证码',
  verifyCodeCellPH: '请输入手机验证码',
  verifyCodeEmailPH: '请输入邮箱验证码',
  email: '邮箱',
  name: '姓名',
  Email: '邮箱',
  emailHP: '请输入正确邮箱，qq邮箱除外',
  obtain: '发送验证码',
  confirm: '确认提交',
  ignore: '暂不确认',
  select_city: '请选择公司所在城市',
  compNameCn_p: '请输入公司中文名',
  compNameEn_p: '请输入公司英文名',
  invalid_characters: '请输入有效信息',
  choose_category: '请选择企业性质',
  emailRules: '邮箱格式错误',
  verify_email_address_msg_correct_qq: '当前不支持qq邮箱，请更换其他邮箱',
  area_code: '请选择',
  mobileRules: '手机号格式错误',
  verify_phone_code: '请输入手机验证码',
  verify_email_code: '请输入邮箱验证码',
  company_exists: '公司名已存在',
  add_success: '操作成功',
  // JCYS-1829
  register_already_tip: '该公司已存在。您可申请加入。',
  register_join_in: '点击申请加入 >>',
  register_already_join: '当前您选择加入公司：',
  register_already_company: '公司所在城市：',
  register_name_en: '您的英文姓名：',
  register_name_cn: '您的中文姓名：',
  register_name_placeholder: '请输入您的姓名，以证明您的身份',
  attention: '提示',
  attention_confirm: '已经申请加入，等待公司管理员审核确认',
  attention_company_name: '当前您已申请加入公司：',
  attention_sure: '点击此处提醒管理员',
  attention_cancel: '撤销加入申请',
  register_name_tips1: '请输入您的中文姓名',
  register_name_tips2: '仅能输入中英文字符及符号，最多50个字',
  register_name_tips3: '请输入您的英文姓名',
  register_name_tips4: '仅能输入英文字符及符号，最多50个字',
  hasRemind: '已提醒',
  remind_second_sure: '请确认是否取消加入该公司的申请？',
  administrator: '管理员：',

  // wcc 弹窗
  i_konw: '我知道了',
  abnormal_info: '去完善',
  miss: '暂不完善',
  auditing: '提交信息尚在审核中，请稍候',
  audit_defeated: '提交信息审核未通过，请重新完善',
  audit_try: '请先完善企业信息再进行尝试',
  wcc_select_city: '公司所在城市',
  wcc_comp_en: '公司英文名称',
  wcc_comp_warn: '请输入公司英文名称',
  wcc_en_name: '英文姓名',
  wcc_en_name_warn: '请输入英文姓名',
  wcc_obtain: '获取验证码',
  wcc_email_warn: '请输入企业邮箱，QQ邮箱除外',
  wcc_email_error: '请输入企业邮箱',
  wcc_email_code_warn: '请输入验证码',
  wcc_ignore: '暂不完善',
  wcc_confirm: '提交',
  wcc_tip:
    '请完善您的信息，用以您在JCtrans上解锁更多服务，如提供咨询、报价、参加会议等',

  abnormal_company: '您当前的公司信息异常，请前往JCtrans APP修改',
  abnormal_account: '您当前的用户信息异常，请前往JCtrans APP修改',
}
export const bindCompany_en = {
  completeInfo: 'Fill in information',
  tip: 'Please fill in your information，you can unlock services on JCtrans such as providing inquiries,quotes,and attending  conference',
  selectCity: 'Select city of company',
  selectCityPH: 'Please enter the city',
  compNameCn: 'Company name（in Chinese）',
  compNameCnPH: 'Please enter the company name in Chinese',
  compNameEn: 'Company name（in English）',
  compNameEnPH: 'Please enter the company name in English',
  industry: 'Industry Sector',
  phone: 'cell phone',
  phonePH: 'Please enter the cell phone',
  verifyCode: 'Verification code',
  verifyCodeCellPH: 'Cell Verification code',
  verifyCodeEmailPH: 'Email Verification code',
  email: 'Email',
  name: 'Name',
  Email: 'E-mail',
  emailHP: 'Please enter official email address, QQ Mail is not available',
  obtain: 'Obtain',
  confirm: 'Confirm',
  ignore: 'Ignore',
  select_city: 'Please enter the city',
  compNameCn_p: 'Please enter company name in Chinese',
  compNameEn_p: 'Please enter company name',
  invalid_characters: 'Invalid characters',
  choose_category: 'Please select enterprise nature',
  emailRules: 'Invalid email address',
  verify_email_address_msg_correct_qq:
    'QQ mailbox is not avaliable, please change to another mailbox',
  area_code: 'select',
  mobileRules: 'Invalid mobile address',
  verify_phone_code: 'Please enter the phone verification code',
  verify_email_code: 'Please enter the email verification code',
  company_exists:
    'The company name already exists in the current national city',
  add_success: 'Success',
  // JCYS-1829
  register_already_tip:
    'The company already exists. Would you like to apply to ',
  register_join_in: 'join in >>',
  register_already_join: 'The company you currently choose to join：',
  register_already_company: 'The city of company ：',
  register_name_en: 'Your English Name：',
  register_name_cn: 'Your Chinese Name：',
  register_name_placeholder: 'Please enter your name to prove your identity',
  attention: 'Attention',
  attention_confirm:
    'Already applied to join, waiting for review and confirmation by the company administrator.  ',
  attention_company_name: 'Name of the company applying to join：',
  attention_sure: 'Reminder to confirm',
  attention_cancel: 'Undo review',
  register_name_tips1: 'please enter your Chinese name',
  register_name_tips2:
    'Only Chinese and English characters and symbols can be entered, with a maximum of 50 words.',
  register_name_tips3: 'Please enter your English name',
  register_name_tips4:
    'Only English characters and symbols can be entered, up to 50 words.',
  hasRemind: 'Reminded',
  remind_second_sure:
    'Please confirm whether to cancel the application to join this company?',
  administrator: 'Administrator: ',

  // wcc 弹窗
  i_konw: 'OK',
  abnormal_info: 'OK',
  miss: 'Ignore',
  auditing:
    'The submitted information is still under review, please wait a moment',
  audit_defeated: 'Submitted information review failed, please improve again',
  audit_try: 'Please complete the company information before attempting again',
  wcc_select_city: 'City of company',
  wcc_comp_en: 'Company name(in EN)',
  wcc_comp_warn: 'Please enter the company name in English',
  wcc_en_name: 'User name(In EN)',
  wcc_en_name_warn: 'Please enter the user name in English',
  wcc_obtain: 'Obtain',
  wcc_email_warn: 'Please enter official email addres, excluding QQ email',
  wcc_email_error: 'Please enter official email',
  wcc_email_code_warn: 'Please enter verification code',
  wcc_ignore: 'Ignore',
  wcc_confirm: 'Submit',
  wcc_tip:
    'Please fill in your information , you can unlock services on jCtrans such as providing inguiries, quotes, and attending conference',
  company_complate: 'Please complete company information first.',
  abnormal_company:
    'The enterprise information is invalid. Please update it in the JCtrans APP.',
  abnormal_account:
    'The user information is invalid. Please update it in the JCtrans APP.',
}
